module.exports = __webpack_public_path__ + "static/elephantorganicmuslin-49257146d387c9e4d69251788c78d6bd.jpeg";